import { TabFilter } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import type { IAiTrackerCampaign } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import type { AssetPermissions } from "app/services/asset-permissions/AssetPermissions";
import type { IWebsiteItem } from "pro-features/components/AutocompleteWebsites/types";

export const doesCampaignMatchFilter = (
    campaign: IAiTrackerCampaign,
    tabIndex: TabFilter,
    permissions: AssetPermissions,
) => {
    const isMyCampaign = permissions.isOwner;
    const isSharedCampaign = !permissions.isOwner;

    return (
        {
            [TabFilter.ALL]: !campaign.isDemo,
            [TabFilter.MY]: isMyCampaign,
            [TabFilter.SHARED]: isSharedCampaign && !campaign.isDemo,
            [TabFilter.DEMO]: campaign.isDemo,
        }[tabIndex] || false
    );
};

export const getDefaultLanguageForCountry = (countryCode: string): string | undefined => {
    try {
        const locale = new Intl.Locale(`und-${countryCode}`).maximize();
        return locale.language !== "und" ? locale.language : undefined;
    } catch {
        return undefined;
    }
};

export const getUniqueCampaignName = (baseName: string, existingNames: string[]): string => {
    const existingNamesSet = new Set(existingNames);

    if (!existingNamesSet.has(baseName)) {
        return baseName;
    }

    let suffix = 2;
    while (existingNamesSet.has(`${baseName} ${suffix}`)) {
        suffix++;
    }

    return `${baseName} ${suffix}`;
};

export const composeCampaignName = (brand: string, countryCode: string, existingNames: string[]): string =>
    getUniqueCampaignName(countryCode ? `${brand} (${countryCode.toUpperCase()})` : brand, existingNames);

export const getUniqueDomainUrls = (domainItems: IWebsiteItem[]): string[] => {
    const seen = new Set<string>();

    return domainItems
        .map(({ url, name }) => url ?? name ?? "")
        .filter((domain) => {
            const normalized = domain.trim().toLowerCase();
            if (!normalized || seen.has(normalized)) {
                return false;
            }

            seen.add(normalized);
            return true;
        });
};
